import React, {Component} from 'react';

export default function RefreshLink({to, className, children}) {
    return <a href={to}
              className={className}>{children}</a>;
}



// WEBPACK FOOTER //
// ./src/components/controls/RefreshLink.jsx